import type { RouteRecordRaw } from 'vue-router'
import UiGallery from './Gallery.vue'

export { default as UiGallery } from './Gallery.vue'

/**
 * The gallery route, ready to spread into an app's router:
 *
 *   import { uiGalleryRoute } from '@fcms/ui/gallery'
 *   const routes = [ …appRoutes, uiGalleryRoute ]
 *
 * It is deliberately a *route object* rather than a plugin. Each app decides
 * where it lives, whether it is behind an auth guard, and whether it ships to
 * production at all — the back office keeps it available to staff for design
 * review, the portal can drop it from the production bundle.
 *
 * `component` is a lazy import so the gallery, which pulls in every primitive
 * and both chart implementations, never lands in an app's initial chunk.
 */
export const uiGalleryRoute: RouteRecordRaw = {
  path: '/_ui',
  name: 'ui-gallery',
  component: () => import('./Gallery.vue'),
  meta: {
    // Consumed by the apps' auth guards; the gallery has no data of its own
    // and needs no permission.
    public: true,
    title: 'Design system',
  },
}

/** The component itself, for an app that mounts it without vue-router. */
export const galleryComponent = UiGallery
